/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel } from "@mui/material";
function Sports({ provider, initData, filterData, handleStepperButtonStatus, handleStepData }) {
  const [checked, setChecked] = useState([]);
  const [selectedSports, setSelectedSports] = useState([]);
  const [sports, setSports] = useState(
    initData
      .filter((sport) => sport.providerId == provider)
      .sort((a, b) => {
        return parseFloat(a.id) - parseFloat(b.id);
      })
  );

  //console.log("Initialization with data: ", JSON.stringify(filterData));

  function setInitData() {
    //console.log("Wizard Sports step initData! ", initData);
    // console.log("Wizard Sports step filterData! ", filterData);
    handleStepperButtonStatus(true);
    if (provider) {
      //sports = initData.filter((sport) => sport.providerId == provider);
      setSports(
        initData
          .filter((sport) => sport.providerId == provider)
          .sort((a, b) => {
            return parseFloat(a.id) - parseFloat(b.id);
          })
      );
    } else {
      //sports = initData;
      setSports(
        initData.sort((a, b) => {
          return parseFloat(a.id) - parseFloat(b.id);
        })
      );
    }
    handleStepperButtonStatus(true);
  }

  function setfilterData(initSports) {
    //console.log("Wizard Sports setfilterData!");

    if (sports.length == 0 && initSports) {
      //sports = initSports;
      setSports(
        initSports.sort((a, b) => {
          return parseFloat(a.id) - parseFloat(b.id);
        })
      );
    }

    if (filterData) {
      //console.log("setSelectedSport: ", JSON.stringify(filterData));
      for (const key in filterData) {
        if (Object.hasOwnProperty.call(filterData, key)) {
          const sport = sports.find((sport) => {
            return sport.id === filterData[key].id;
          });
          sport.selected = true;
          setChecked([sport.selected, checked[sport.name]]);
        }
      }
      setSelectedSports(filterData);
    }

    //setSports(sports);

    if (filterData && filterData.length > 0) {
      handleStepperButtonStatus(false);
    } else {
      handleStepperButtonStatus(true);
    }
  }

  const handleSportChange = (event) => {
    setChecked([event.target.checked, checked[event.target.name]]);
    const tmpSelectedSports = [...selectedSports];
    const sportId = parseInt(event.target.name);
    const sport = sports.find((sport) => {
      return sport.id === sportId;
    });
    sport.selected = !sport.selected;
    if (event.target.checked) {
      tmpSelectedSports.push(sport);
    } else {
      const previousRowsIndex = tmpSelectedSports.findIndex((rowSport) => rowSport.id === sport.id);
      tmpSelectedSports.splice(previousRowsIndex, 1);
    }

    setSelectedSports([]);
    setSelectedSports(tmpSelectedSports);
    handleStepData(tmpSelectedSports);

    if (tmpSelectedSports.length > 0) {
      handleStepperButtonStatus(false);
    } else {
      handleStepperButtonStatus(true);
    }
  };

  const handleAllSelection = (event, status, group) => {
    event.preventDefault();
    let lastSelectedSports = [...selectedSports];
    const tmpSelectedSports = [];
    const esport = group === "sports" ? false : true;
    sports
      .filter((sport) => sport.enabled)
      .filter((s) => s.is_esport == esport)
      .forEach((sport) => {
        sport.selected = status;
        if (status) tmpSelectedSports.push(sport);
      });

    lastSelectedSports = lastSelectedSports.filter((s) => s.is_esport != esport);

    const newSelectedSports = lastSelectedSports.concat(tmpSelectedSports);

    setSelectedSports([]);
    setSelectedSports(newSelectedSports);
    handleStepData(newSelectedSports);

    if (newSelectedSports.length > 0) {
      handleStepperButtonStatus(false);
    } else {
      handleStepperButtonStatus(true);
    }
  };

  useEffect(() => {
    setInitData();
  }, [initData]);

  useEffect(() => {
    if (filterData) setfilterData();
  }, [filterData]);

  return (
    <SoftBox>
      <SoftBox width="80%" textAlign="center" mx="auto" mb={4}>
        <SoftBox mb={1}>
          <SoftTypography variant="h5" fontWeight="regular">
            Now its time to select the Sports you want
          </SoftTypography>
        </SoftBox>
        <SoftTypography variant="body2" fontWeight="regular" color="text">
          Let us know which Sports you want to deliver to you
        </SoftTypography>
      </SoftBox>
      <SoftBox mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} container justifyContent="center">
            <SoftBox position="relative" height="max-content" mx="auto">
              <FormControl>
                <div>
                  <FormGroup row className="wizard-select-all-holder">
                    <FormLabel id="demo-radio-buttons-group-label">Available Sports</FormLabel>
                    <SoftBox mt={2} style={{ marginLeft: "auto" }}>
                      <SoftButton
                        variant="outlined"
                        color="info"
                        size="small"
                        sx={{
                          marginLeft: "5px",
                          marginBottom: "5px",
                          minWidth: "100px",
                          padding: "0px !important",
                        }}
                        onClick={(e) => handleAllSelection(e, true, "sports")}
                      >
                        Select all
                      </SoftButton>
                      <SoftButton
                        variant="outlined"
                        color="info"
                        size="small"
                        sx={{
                          marginLeft: "5px",
                          marginBottom: "5px",
                          minWidth: "100px",
                          padding: "0px !important",
                        }}
                        onClick={(e) => handleAllSelection(e, false, "sports")}
                      >
                        Diselect all
                      </SoftButton>
                    </SoftBox>
                  </FormGroup>
                </div>

                <FormGroup row>
                  {sports
                    .filter((s) => !s.is_esport)
                    .map((sport) => (
                      <FormControlLabel
                        className={sport.masterFeed ? "sports-checkbox-master" : "sports-checkbox"}
                        control={
                          <Checkbox
                            disabled={!sport.enabled}
                            checked={sport.selected}
                            onChange={handleSportChange}
                            name={String(sport.id)}
                          />
                        }
                        key={sport.id}
                        label={sport.name}
                        title={
                          sport.masterFeed
                            ? "This Sport is fed from Master Feed Provider"
                            : sport.name
                        }
                      />
                    ))}
                </FormGroup>
                <FormGroup row className="wizard-select-all-holder">
                  <FormLabel id="esports-group-label">Available eSports</FormLabel>
                  <SoftBox mt={2} style={{ marginLeft: "auto", marginTop: "30px !important" }}>
                    <SoftButton
                      variant="outlined"
                      color="info"
                      size="small"
                      sx={{
                        marginLeft: "5px",
                        marginBottom: "5px",
                        minWidth: "100px",
                        padding: "0px !important",
                      }}
                      onClick={(e) => handleAllSelection(e, true, "esports")}
                    >
                      Select all
                    </SoftButton>
                    <SoftButton
                      variant="outlined"
                      color="info"
                      size="small"
                      sx={{
                        marginLeft: "5px",
                        marginBottom: "5px",
                        minWidth: "100px",
                        padding: "0px !important",
                      }}
                      onClick={(e) => handleAllSelection(e, false, "esports")}
                    >
                      Diselect all
                    </SoftButton>
                  </SoftBox>
                </FormGroup>
                <FormGroup row>
                  {sports
                    .filter((s) => s.is_esport)
                    .map((sport) => (
                      <FormControlLabel
                        className={sport.masterFeed ? "sports-checkbox-master" : "sports-checkbox"}
                        control={
                          <Checkbox
                            disabled={!sport.enabled}
                            checked={sport.selected}
                            onChange={handleSportChange}
                            name={String(sport.id)}
                          />
                        }
                        key={sport.id}
                        label={sport.name}
                        title={
                          sport.masterFeed
                            ? "This Sport is fed from Master Feed Provider"
                            : "e-sport / " + sport.name
                        }
                      />
                    ))}
                </FormGroup>
              </FormControl>
            </SoftBox>
          </Grid>
        </Grid>
      </SoftBox>
    </SoftBox>
  );
}

// Typechecking props for the DataTable
Sports.propTypes = {
  provider: PropTypes.number,
  initData: PropTypes.array,
  filterData: PropTypes.array,
  handleStepperButtonStatus: PropTypes.func,
  handleStepData: PropTypes.func,
};

export default Sports;
